import React, { ChangeEvent, FC, useCallback } from 'react';
import { Form, Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import { FormItemProps } from 'antd/lib/form';
import { useField, FieldHookConfig } from 'formik';
import { InputFormatters } from '@shared/utils';

export type TextFieldProps = FieldHookConfig<string> & {
  item?: FormItemProps;
  input?: InputProps;
  format?: 'text' | 'integer' | 'decimal';
};

export const TextField: FC<TextFieldProps> = ({ item, input, format = 'text', ...props }) => {
  const [field, meta] = useField(props);

  const customOnChange = input?.onChange;

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      let formattedEvent = event;

      if (format === 'decimal') {
        formattedEvent = InputFormatters.decimal(event);
      } else if (format === 'integer') {
        formattedEvent = InputFormatters.integer(event);
      }

      return customOnChange ? customOnChange(formattedEvent) : field.onChange(formattedEvent);
    },
    [format, field, customOnChange],
  );

  const inputProps = { ...input, onChange };

  return (
    <Form.Item {...item} validateStatus={meta.touched && !!meta.error ? 'error' : undefined} help={meta.touched ? meta.error : undefined}>
      <Input {...field} {...inputProps} value={field.value ?? ''} />
    </Form.Item>
  );
};
